<template>
  <div class="mt-4 pr-0 pl-0 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)">
    <v-dialog v-model="dialoghargakhusus" persistent max-width="500">
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-toolbar-title>Tambah Harga Khusus</v-toolbar-title>
          <v-spacer/>
          <v-btn @click="setdialoghargakhusus(false)"  icon><v-icon>close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form lazy-validation class="mt-4">
            <div class="mt-6">
              <v-autocomplete
                  label="Pembeli "
                  clearable
                  item-text="membername"
                  item-value="memberid"
                  placeholder="Cari Pembeli..."
                  :loading="loadingbuyer"
                  :search-input.sync="searchbuyer"
                  @change="getnBrandsByid(newdata.categoryid)"
                  v-model="newdata.memberid"
                  :items="buyers">
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title>
                      Cari pembeli...
                    </v-list-item-title>
                  </v-list-item>
                </template>
                <template v-slot:selection="{ attr, on, item, selected }">
                  <v-chip v-bind="attr" :input-value="selected"
                      v-on="on">
                    <v-list-item-avatar left>
                      <v-img :src="item.memberavatar"></v-img>
                    </v-list-item-avatar>
                    <span v-text="item.membername"></span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <v-list-item-avatar
                      color="indigo" class="text-h5 font-weight-light white--text">
                    <v-img :src="item.memberavatar"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.membername"></v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </div>
            <div class="mt-0">
              <v-autocomplete
                  label="Categori "
                  item-text="name"
                  item-value="id"
                  @change="getnBrandsByid(newdata.categoryid)"
                  v-model="newdata.categoryid"
                  :items="category">
              </v-autocomplete>
            </div>
            <v-autocomplete
                label="Brand/Operator"
                item-text="brandname"
                item-value="id"
                v-model="newdata.brandid"
                @change="getSellerProductByBrandID(newdata.brandid)"
                :items="nbrands">
            </v-autocomplete>
            <v-select
                label="Produk"
                item-text="productname"
                item-value="id"
                return-object
                @change="getProductSellerByID(newdata.product.id)"
                v-model="newdata.product"
                :items="selectproductbybrand">
            </v-select>
            <v-container>
              <v-row>
                <v-text-field class="mr-2" v-model="newdata.product.productcode" readonly label="Kode Market"></v-text-field>
              </v-row>
            </v-container>
            <v-container>
              <v-row>
                <v-text-field readonly v-model="newdata.product.sellprice" type="number" label="Harga Normal"></v-text-field>
                <v-text-field v-model="newdata.price" type="number" label="Harga Khusus"></v-text-field>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="setdialoghargakhusus(false)" dark class="red">Tutup</v-btn>
          <v-btn text dark  @click="simpantambah" class="primary">Simpan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar elevation="0">
      <v-text-field
          flat
          solo
          dense
          outlined
          clearable
          prepend-inner-icon="search"
          placeholder="Type something"
          v-model="opsitable.search"
          hide-details
          class=""
      ></v-text-field>
      <v-spacer/>
      <div class="mt-5 mr-2">
        <v-autocomplete
            clearable
            label="Category"
            @change="getProductSeller(opsitable)"
            item-text="name"
            item-value="id"
            v-model="opsitable.categoryid"
            :items="category"
        ></v-autocomplete>
      </div>
      <div class="mt-5 mr-2">
        <v-autocomplete
            clearable
            label="Brand"
            @change="getProductSeller(opsitable)"
            item-text="brandname"
            item-value="id"
            v-model="opsitable.brandid"
            :items="brands"
        ></v-autocomplete>
      </div>
      <v-btn small elevation="0" class="ml-2" color="primary" @click.native="opennew">
        <v-icon dark>add</v-icon>Tambah
      </v-btn>
      <v-btn small elevation="0" class="ml-2" color="primary" @click.native="getProductSpecial(opsitable)">
        <v-icon dark>refresh</v-icon>Refresh
      </v-btn>
    </v-toolbar>
    <v-divider/>
    <v-data-table
        dense
        :headers="headers"
        :search="opsitable.search"
        :items="hargakhusus"
        class="elevation-0"
        item-key="id"
        :options.sync="opsitable"
        :server-items-length="totalhargakhusus"
        :loading="loading"
        @update:options="getProductSpecial(opsitable)">

      <template v-slot:item.hargajual="{ item }">
        <div  class="text-right">
          {{formatAngka(item.hargajual)}}
        </div>
      </template>
      <template v-slot:item.discount="{ item }">
        <div  class="text-right">
          {{formatAngka(item.discount)}}
        </div>
      </template>
      <template v-slot:item.stok="{ item }">
        <div  class="text-right">
          {{formatAngka(item.stok)}}
        </div>
      </template>
      <template v-slot:item.statustoko="{ item }">
        <div class="ma-4 text-xs-left">
          <v-chip
              :color="colorStatus(item.statustoko)"
              small
              text-color="white">
            {{ tokostatustext(item.statustoko) }}
          </v-chip>
        </div>
      </template>
      <template v-slot:item.sellername="{ item }">
        <div @click="gosellerpage(item.sellerid)" style="cursor: pointer;">{{item.sellername}}</div>
      </template>
      <template v-slot:item.status="{ item }">
        <div class="ma-4 text-xs-left">
          <v-chip
              :color="colorStatus(item.status)"
              small
              text-color="white">
            {{ statusText(item.status) }}
          </v-chip>
        </div>
      </template>
      <template v-slot:item.aksi="{ item }">
        <v-btn @click="openedit(item)" fab x-small text dark class="blue"><v-icon>edit</v-icon></v-btn>
        <v-btn x-small dark fab text @click.native="hapus(item)" class="red ml-2">
          <v-icon small>delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Utils from '@/plugins/utils'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'HargaKhusus',
  data: () => ({
    searchbuyer: '',
    newdata: {
      memberid: 0,
      categoryid: 0,
      brandid: 0,
      productid: 0,
      product: {},
      sellprice: 0,
      price: 0,
      stok: 0
    },
    opsitable: {
      search: '',
      itemsPerPage: 10,
      page: 1,
      paymentstatus: '',
      sortBy: ['id']
    },
    headers: [
      {
        text: 'Id',
        value: 'id'
      },
      {
        text: 'Member',
        value: 'member.membername'
      },
      {
        text: 'Brand',
        value: 'product.brand.brandname'
      },
      {
        text: 'Produk',
        value: 'product.productname',
        groupable: false
      },
      {
        text: 'Kode',
        value: 'product.productcode',
        groupable: false
      },
      {
        text: 'Harga Jual',
        value: 'hargajual',
        align: 'right',
        groupable: false
      },
      {
        text: 'Status',
        value: 'status'
      },
      {
        text: 'Aksi',
        value: 'aksi',
        groupable: false
      }
    ]
  }),
  watch: {
    searchbuyer (val) {
      this.getBuyerList(val)
    }
  },
  computed: {
    ...mapState('ProductStore', ['category', 'brands']),
    ...mapState('SellerStore', ['selectproductbybrand', 'selectproductseller', 'dialoghargakhusus', 'nbrands', 'nproduct', 'loadingbuyer', 'loading', 'buyers', 'hargakhusus', 'totalhargakhusus'])
  },
  methods: {
    ...mapActions('ProductStore', ['getBrands']),
    ...mapActions('SellerStore', ['getSellerProductByBrandID', 'getProductSellerByID', 'setdialoghargakhusus', 'getnBrandsByid', 'getnProductByBrandId', 'getBuyerList', 'getProductSpecial', 'delProductSpecial', 'addProductSpecial']),
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    },
    colorStatus (val) {
      if (parseInt(val) === 1) {
        return 'green'
      } else {
        return 'red'
      }
    },
    toupper (val) {
      return val.toUpperCase()
    },
    tokostatustext (val) {
      if (val === 1) {
        return 'Buka'
      } else {
        return 'Tutup'
      }
    },
    statusText (val) {
      if (parseInt(val) === 1) {
        return 'Aktif'
      } else {
        return 'Non Aktif'
      }
    },
    simpantambah () {
      this.newdata.productid = this.newdata.product.productid
      this.addProductSpecial(this.newdata)
    },
    formatAngka (val) {
      return Utils.formatAngka(val)
    },
    opennew () {
      this.newdata = {
        memberid: 0,
        categoryid: 0,
        brandid: 0,
        productid: 0,
        product: {},
        sellprice: 0,
        price: 0,
        stok: 0
      }
      this.setdialoghargakhusus(true)
    },
    openedit (item) {
      console.log(item)
    },
    hapus (val) {
      this.$confirm('Yakin akan Hapus ' + val.product.productname + ' Pembeli:' + val.member.membername, { color: 'red', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          this.delProductSpecial(val)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
